<template>
  <div class="upcoming">
    <template v-if="data_userId">
      <div class="title">
        <div>
          <img src="../../assets/img/icon_player.png" alt="">
        </div>
        <h3>已购课程</h3>
        <span v-if="data_upcoming.length" @click="onMore_fn(data_userId)">查看更多</span>
      </div>

      <!-- 是否有我的课程 -->
      <Empty v-if="!data_upcoming.length" :description="empty_null_text"/>
      <ul v-else>
        <li @click="coming_fn(item.id)" v-for="(item,index) in data_upcoming" :key="index">
          <img :src="item.cover" alt="">
          <div class="upcoming_msg">
            <h5>{{item.name}}</h5>
            <!-- 讲者信息-->
            <dl class="author">
              <dd v-for="(v,i) in item.pcSpeakerList" :key="i">
                <img v-if="i<3" :src="v.avatar" alt="">
                <span v-if="i>=3">...</span>
              </dd>
            </dl>
          </div>
        </li>
      </ul>
    </template>
    <!-- 未登录 -->
    <template v-else>
      <div class="title">
        <div>
          <img src="../../assets/img/icon_player.png" alt="">
        </div>
        <h3>我的课程</h3>
      </div>
      <div class="login">
        <span>查看已购买课程</span>
        <b @click="onlogin_fn">请登录</b>
      </div>
    </template>
  </div>
  <Modal v-model:data_isShow="isShow_b">
    <div class="modal_none">
      <img :src="modelImg" alt="">
      该课程暂未上线，敬请期待!
    </div>
  </Modal>

</template>

<script>
  import Modal from '@c/Modal.vue';
  import { syslogin } from "@/utils/methods.js";
  import { Empty } from "ant-design-vue";
  import { btn_click } from "../../utils/AnalysysAgent";

  export default {
    name: "IndexUpcoming",
    components: {Modal,Empty},
    props:['data_upcoming','data_userId'],
    data() {
      return {
        empty_null_text:'暂无课程',
        isShow_b: false,
        modelImg: require('@/assets/img/guide_mp_s.png'),
      }
    },
    methods: {
      // 即将上线 弹窗
      coming_fn(id) {
        const routeLink = this.$router.resolve({
          path:  '/pages/coursePlay/coursePlay',
          query: {
            courseId: id
          }
        })
        window.open(routeLink.href, '_blank');
        // this.isShow_b = true;
        // this.$router.push('/pages/coursePlay/coursePlay?courseId=' + id);
      },
      // 登录
      onlogin_fn(){
        syslogin();
      },
      // 我的课程页面
      onMore_fn(id){
        btn_click("我的课程-查看更多",document.title)
        this.$router.push('/myCourses');
      }
    }
  }
</script>

<style scoped lang="scss">
  $carousel_height: 262px; // 轮播高度
  /* 即将上线 */
  .upcoming {
    @extend %defaultBg;
    width: 394px;
    height: $carousel_height;
    border-radius: 6px;
    margin-left: auto;
    padding: 12px 15px;
    display: flex;
    flex-direction: column;

    .title {
      display: flex;
      align-items: center;

      div{
        display: flex;
        /*background: #0681CE;*/
        margin-right: 10px;

        img {
          width: 20px;
          height: 20px;
        }
      }
      h3 {
        font-size: 20px;
        color: #000;
        font-weight: bold;
      }
      span{
        margin-left: auto;
        display: flex;
        align-items: center;
        color: #0581ce;
        cursor: pointer;

        &::after{
          content: "";
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 3px solid transparent;
          border-left: 6px solid #0581ce;
          border-bottom: 3px solid transparent;
          margin-left: 3px;
        }
      }
    }

    ul {
      @extend %scrollStyle;
      height:202px;
      overflow: auto;

      li {
        display: flex;
        margin-top: 10px;
        cursor: pointer;
        border-radius: 6px;

        & > img {
          width: 160px;
          height: 90px;
          border-radius: 6px;
          overflow: hidden;
          margin-right: 14px;
        }

        .upcoming_msg {
          display: flex;
          flex: 1;
          width: 0;
          flex-direction: column;
          justify-content: flex-end;

          h5 {
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: bold;
          }

          .author {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            margin-top:28px;

            img {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              background: #333333;
              margin-right: -10px;
              border: 1px solid #eee;
            }

            span {
              background: #d7d7d7;
              border: #eee;
              width: 28px;
              height: 28px;
              border-radius: 50%;
              display: inline-block;
              margin-right: -10px;
              text-align: center;
              border: 1px solid #eee;
            }
          }
        }
      }
    }
  }

  .login{

    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;

    span{
      font-size: 16px;
    }

    b{
      font-size: 14px;
      line-height: 42px;
      width: 112px;
      text-align: center;
      color:#fff;
      background: #0581CE;
      border-radius: 6px;
      margin-top:20px;
      cursor: pointer;
    }
  }

  .modal_none {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 100px 50px;
    color:$theme_blue;
    font-size: 22px;

    img {
      width: 70px;
      margin-right: 12px;
    }
  }
  .ant-empty{
    margin-top:30px;
  }
</style>
